import api from '../api';

const controller = 'crfContratosEspeciais';

export interface CrfContratoEspecial {
  id: string;
  ano: number;
  mes: number;
}

export interface CrfContratoEspecialTableData {
  id: string;
  indice: number;
  numeroContrato: string;
  nomeFornecedor: string;
  nomeMatriz: string;
  cnpj: string;
  codigoFornecedor: number;
  especial: boolean;
}

export const getAllCrfContratosEspeciais = () => api.get<CrfContratoEspecial[]>(controller);

export const getCrfContratoEspecialById = (id: string) => api.get<CrfContratoEspecial>(`${controller}/${id}`);

export const getDataByCrfContratoId = (id: string) =>
  api.get<CrfContratoEspecialTableData[]>(`${controller}/${id}/data`);

export const updateStatusCrfContratoEspecial = (id: string, especial: boolean) =>
  api.put<CrfContratoEspecialTableData>(`${controller}/${id}/`, { id, especial });
